/**
 * Toggle company fields on checked checkbox
 * ======================================
 * - jquery needed
 */
import $ from "jquery";

$("#company_checkbox").on("change", function() {
  $(".js-woocommerce-company-field").toggleClass("form-row-hidden");
});

$("body").on("click", ".js-redirect", function(e) {

	window.location.href = "https://www.irobot.ro/dealeri-autorizati/";

	e.preventDefault();
});
